<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center">
              <div class="header-icon-wrap mr-3">
                <i class="fe fe-list" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Manage Encounters</h4>
                <small style="opacity: 0.8;">
                  <span v-if="encounters != ''">{{ encounters.meta.total }}</span> encounters
                </small>
              </div>
            </div>
            <div class="d-flex" style="gap: 8px;">
              <button class="btn btn-light btn-sm" style="border-radius: 8px; font-weight: 600;"
                @click="encounterform = !encounterform">
                <i class="fe mr-1" :class="encounterform ? 'fe-x' : 'fe-plus'"></i>
                {{ encounterform ? 'Close' : 'Add Code' }}
              </button>
              <button class="btn btn-outline-light btn-sm" style="border-radius: 8px; font-weight: 600;"
                @click="filterparams = !filterparams">
                <i class="fe fe-filter mr-1"></i> Filter
              </button>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- Encounter code form -->
          <div v-show="encounterform" class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number"><i class="fe fe-plus" style="font-size: 13px;"></i></div>
              <h6 class="mb-0 font-weight-bold text-white">Add Encounter Code</h6>
            </div>
            <div class="card-body px-4 py-4">
              <form @submit.prevent="sendCode">
                <div class="form-group">
                  <label class="info-label d-block mb-1">Encounter Code</label>
                  <input type="text" required class="form-control" v-model="string_data"
                    placeholder="EC0/000/000/000" />
                </div>

                <button type="submit" class="btn btn-submit">
                  <i class="fe fe-send mr-1"></i> Submit
                </button>
              </form>
            </div>
          </div>

          <!-- Filter form -->
          <div v-show="filterparams" class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number"><i class="fe fe-filter" style="font-size: 13px;"></i></div>
              <h6 class="mb-0 font-weight-bold text-white">Filter Encounters</h6>
            </div>
            <div class="card-body px-4 py-4">
              <div class="row">
                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">Agency ID</label>
                  <input type="text" class="form-control" v-model="filter_field.enrollee" placeholder="ID/XXX/XXXXX" />
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">Diagnosis</label>
                  <v-select multiple v-model="filter_field.diagnoses" :reduce="(name) => name.id" label="name"
                    :options="diseases" />
                </div>



                <div class="form-group col-md-6" v-if="user.type == 'shis' || user.type == 'employee'"
                  :reduce="agency_name => agency_name.id">
                  <label class="info-label d-block mb-1">Select Facility</label>
                  <v-select v-model="filter_field.providers" label="agency_name" :options="providers" multiple />
                </div>





                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>Start Date</label>
                  <input type="date" class="form-control" v-model="filter_field.from" />
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>End Date</label>
                  <input type="date" class="form-control" v-model="filter_field.to" />
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">Rows</label>
                  <select class="form-control" v-model="paginate_value">
                    <option>30</option>
                    <option>100</option>
                    <option>500</option>
                    <option>1000</option>
                    <option>5000</option>
                    <option>10000</option>
                  </select>
                </div>
              </div>

              <div class="d-flex" style="gap: 8px;">
                <button class="btn btn-submit" @click="getEncounters('json')">
                  <i class="fe fe-search mr-1"></i> Filter
                </button>
                <button class="btn btn-outline-secondary" @click="getEncounters('csv')">
                  <i class="fe fe-download mr-1"></i> Export CSV
                </button>
              </div>
            </div>
          </div>

          <!-- Encounters table -->
          <div class="card shadow-sm table-card">
            <div class="d-flex align-items-center px-4 pt-4 pb-3">
              <i class="fe fe-list text-primary mr-2"></i>
              <h6 class="mb-0 font-weight-bold">Encounters</h6>
              <span v-if="encounters != ''" class="badge badge-soft-info ml-2">{{ encounters.meta.total }}</span>
            </div>
            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead class="table-head">
                  <tr>
                    <th class="table-th">Encounter ID</th>
                    <th class="table-th">Facility</th>
                    <th class="table-th">Patient</th>
                    <th class="table-th">Phone Number</th>
                    <th class="table-th">Diagnosis</th>
                    <th class="table-th">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="encounter in encounters.data" v-bind:key="encounter.id" class="table-row">
                    <td class="py-3 px-4">
                      <span v-if="encounter.healthrecord != null">
                        {{ encounter.healthrecord.encounter_id }}
                      </span>
                    </td>
                    <td class="py-3">
                      <span v-if="encounter.provider != null">
                        {{ encounter.provider.agency_name }}
                      </span>
                    </td>
                    <td class="py-3 font-weight-bold">
                      <span v-if="encounter.enrollee != null">
                        {{ encounter.enrollee.full_name }}</span>
                    </td>
                    <td class="py-3 text-muted small">
                      <span v-if="encounter.enrollee != null">
                        {{ encounter.enrollee.phone_number }}</span>
                    </td>
                    <td class="py-3">
                      {{ encounter.diagnosis.name }}
                    </td>

                    <td class="py-3 pr-4">
                      <router-link :to="{ path: '/encounter/' + encounter.id }">
                        <button type="button" class="btn btn-sm btn-submit" name="button">
                          <i class="fe fe-eye"></i>
                        </button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="encounters == '' || !encounters.data || !encounters.data.length">
                    <td colspan="6" class="text-center py-5 text-muted">
                      <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No encounters. Use the filter to search.</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="vld-parent">
            <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin

  export default {
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        paginate_value: 30,
        user: null,
        isLoading: false,
        encounterform: false,
        fullPage: true,
        filterparams: false,
        diseases: "",
        providers: "",
        string_data: "",
        encounters: {
          meta: {},
        },
        filter_field: {
          diagnosis: "",
          provider_id: "",
          enrollee: "",
          date: "",
          from: "",
          to: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/diagnosis-agency/407465`)
        .then((response) => {
          this.diseases = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    methods: {
      getEncounters(format) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/service_summary-agency`, {
            format: format,
            providers: this.filter_field.providers,
            enrollee: this.filter_field.enrollee,
            diagnoses: this.filter_field.diagnoses,
            date: this.filter_field.date,
            from: this.filter_field.from,
            to: this.filter_field.to,
            agency_id: 407465,
            paginate_value: this.paginate_value,
          })
          .then((response) => {

            if (format === "csv") {
              const blob = new Blob([response.data], {
                type: "text/csv;charset=utf-8;",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `encounters_${new Date().toISOString().slice(0, 10)}.csv`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);

              this.$toasted.success("CSV downloaded successfully", {
                position: "top-center",
                duration: 3000,
              });

              this.isLoading = false;
              return;
            }

            this.isLoading = false;

            this.encounters = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      sendCode() {
        if (confirm("Are you Sure you want submit")) {
          this.isLoading = true;
          this.axios
            .post(`/api/v1/auth/get-string`, {
              string_data: this.string_data,
              agency_id: 407465,
            })
            .then((response) => {
              console.log(response);
              this.getEncounters('json');
              //  this.$router.push(`/encounter/${encounter_id}`);
              this.string_data = "";
              this.isLoading = false;
              this.$toasted.info("Encounted submitted Successfully!", {
                position: "top-center",
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);
              this.isLoading = false;
              this.$toasted.error("Code Error!", {
                position: "top-center",
                duration: 3000,
              });
            });
        }
      },
      getProviders() {
        this.axios
          .get(`/api/v1/auth/providerAgency/407465`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
    created() {
      this.getEncounters();
      this.getProviders();
    },
  };
</script>